import { connect } from 'react-redux';
import React, { Component } from 'react';
import routerActions from 'app/routerActions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { api, apiUtils } from 'app/services';
import { KBAvatar } from 'components';
import {
locationActions,
getLocationMembersAction,
floorplansAction,
locationRoleAction,
locationSettingAction,
areaActions,
reservationsActions,
loadingAction,
meetingsActions,
orgActions,
apiCallFailure,
groupsActions } from
'app/actions';
import classNames from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import {
ORG_SUBSCRIPTION_STATES,
ORG_SUBSCRIPTION_STATES_CLASS,
INVOICES_STATE,
INVOICES_STATE_CLASS,
OFFICE_AREA_STATE } from
'app/constants';
import { util, isHideModule, groupLocationsByCity } from 'utils/kbUtil';
import * as selectors from 'app/selectors';
import {
canAdminSpace,
canAccessLocationRoles,
canSpaceAdmin,
canAccessLocation,
canAccessLocationObserver,
canAccessLocationOnlyFinance,
canAccessLocationRepairOnly } from
'app/reducers/role';
import * as kbData from 'utils/kbData';
import _ from 'lodash';
import { getUserInfoUrl } from 'utils/kbUrl';

var GroupBox = class extends React.Component {constructor(props) {super(props);this.rootRef = React.createRef();this.transitionNodeRef = React.createRef();this.state = this.getInitialState();this.changeParentScrollTop = this.changeParentScrollTop.bind(this);this._loadData = this._loadData.bind(this);this.selectKbOutBox = this.selectKbOutBox.bind(this);}getInitialState()

  {
    return {
      invoices: [],
      contracts: [],
      desks: [],
      searchResult: [],
      searchingOrgs: false };

  }changeParentScrollTop()

  {
    if (this.rootRef.current) {
      this.rootRef.current.scrollTop = 0;
    }
  }componentDidMount()

  {
    const { location_id, isRepair, routerActions } = this.props;
    this._loadData(location_id);
  }_loadData(

  location_id) {
    const { isRepair, user, getGroupsInfoAction } = this.props;

    api.getGroupsInfo(location_id).then(
    json => {
      getGroupsInfoAction.success(json);
    },
    errors => {
      getGroupsInfoAction.failure(errors);
    });

  }selectKbOutBox()

  {}render()

  {
    const { location_id, locations, user, isRepair } = this.props;
    if (!locations.length) {
      return <div></div>;
    }
    return (
      <div className="kb-out-box clear-fix" ref={this.rootRef}>
        {this.props.children &&
        <TransitionGroup
        onClick={this.selectKbOutBox}
        className="margin-top-lg"
        component="div">

            <CSSTransition
          key={this.props.pathname}
          nodeRef={this.transitionNodeRef}
          classNames="example"
          timeout={{ enter: 500, exit: 0 }}
          children={
            <div ref={this.transitionNodeRef}>
              {React.cloneElement(React.Children.only(this.props.children), {
                changeParentScrollTop: this.changeParentScrollTop })}
            </div>
          } />
          </TransitionGroup>}

      </div>);

  }};


function mapStateToProps(state, props) {
  let location_id = props.params.id;
  let locations = selectors.getLocations(state);
  let user = selectors.getCurrentUser(state);
  var pathname = props.location.pathname.split('/');
  // let isManager = canAccessLocation(user, location_id)
  // let isRepair = canAccessLocationRepairOnly(user, location_id)
  const group = selectors.getCurrentGroup(state, location_id);

  if (pathname.length > 5) {
    pathname = pathname.slice(0, 5);
  }

  return {
    pathname: pathname.join('/'),
    location_id,
    locations,
    user,
    // isManager,
    // isRepair,

    group };

}

// Map action creators dispatch to props
// So we can call this.props.<actionName>.request(<params>) directly
function mapDispatchToProps(dispatch) {
  return {
    getGroupsInfoAction: bindActionCreators(groupsActions.update, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

export default connect(mapStateToProps, mapDispatchToProps)(GroupBox);
